import { Component, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import { TrackeritemRest } from '../../../plugins/tracker/services/trackeritem.rest';
import { UserService } from '../../../core/services/core.user.service';

@Component({
    selector: 'reactions-dropdown',
    template: require('./reactions-dropdown.component.html')
  })
  export class ReactionsDropdownComponent {
    @Input() src: any;
    @Input() trackerItem: any;
    @Input() messageId: any;
  
    currentGlyph: string | undefined;
    reactionsList: string[] = ['heart', 'thumbs-up', 'thumbs-down', 'question-sign'];
  
    constructor(private trackerItemRest: TrackeritemRest, private userService: UserService) {}
  
    ngOnInit(): void {
      this.setCurrentGlyph();
    }
  
    setCurrentGlyph(): void {
      const unixName = this.userService.session.getUnixName();
      this.currentGlyph = _.get(this, `src.reactions.${unixName}`);
    }
  
    setReaction(glyph: string): void {
      const data = {
        reaction: glyph === this.currentGlyph ? '' : glyph,
      };
  
      this.trackerItemRest.postReaction(this.trackerItem.id, this.messageId, data)
      .then((result: any) => {
          // Update the parent timeline item with the new reaction list
          this.src.reactions = _.get(result, 'reactions', []);
          this.setCurrentGlyph();
      },
      (failure: any) => {
          console.log(failure);
      });
    }
  }
  